// dropdown/DropdownMenu.js
import React, {useEffect, useRef, useState} from 'react';
import "./dropdown-menu.css"
import "./dropdown-menu-responsive.css"
import {faCaretDown, faCaretUp, faMinus, faPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

const DropdownMenu : React.FC<({mobileMenuOpen: boolean})> = props => {

    // const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement | null>(null); // Specify the type for the ref
    const [dpOpen, setDpOpen] = useState(false);

    const { t, i18n } = useTranslation();


    // Close dropdown when clicking outside
    const toggleDropdown = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent event from bubbling up to window
        setDpOpen((prevState) => !prevState); // Toggle dropdown open/close state
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setDpOpen(false); // Close dropdown if clicked outside
            }
        };
        window.addEventListener("click", handleClickOutside);
        return () => {
            window.removeEventListener("click", handleClickOutside);
        };
    }, []);

    return (
        <div className={`dropdown_container ${dpOpen ? 'open_k' : ''}`} ref={dropdownRef} onClick={toggleDropdown}>
            <span className="dropdown-toggle_k" onClick={toggleDropdown}>
                Services
                {!dpOpen && props.mobileMenuOpen && (
                    <FontAwesomeIcon className="dropdown_icon" icon={faPlus}  />
                )}
                {dpOpen && <FontAwesomeIcon className="dropdown_icon" icon={faMinus} />}
                {/* Desktop icon always toggles */}
                <FontAwesomeIcon className="dropdown_icon_desktop" icon={dpOpen ? faCaretUp : faCaretDown} />
            </span>
            {dpOpen && (
                <ul className="dropdown_sub_menu_container">
                    <li className="dropdown_menu_links"><Link to="/services/web-design" className="dropdown_menu_links">{String(t('footer.webDesign'))}</Link></li>
                    <li className="dropdown_menu_links"><Link to="/services/web-applications" className="dropdown_menu_links">{String(t('footer.webApplications'))}</Link></li>
                </ul>
            )}
        </div>
    );
};

export default DropdownMenu;
